import { getProductUrl, isMultiShadeProduct } from "../../utils/internal";
import { mapHasAutoSubscription } from "../mapHasAutoSubscription";
import { mapLabels } from "../mapLabels";
import { mapShades } from "../mapShades";
import { mapShowQuickBuyButton } from "../mapShowQuickBuyButton";
export var mapProductBoxProps = function mapProductBoxProps(data) {
  var _data$formattedPrice, _data$concept, _data$concept2, _data$concept3, _data$concept$brand, _data$backInStockAvai, _data$productCode, _data$imageUrl, _data$formattedPrice$, _data$formattedPrice$2, _data$concept$ratingA, _data$concept$ratingC, _data$productCode2;
  var currentFormatted = (_data$formattedPrice = data.formattedPrice) === null || _data$formattedPrice === void 0 || (_data$formattedPrice = _data$formattedPrice.price) === null || _data$formattedPrice === void 0 ? void 0 : _data$formattedPrice.currentPrice;
  var name = (_data$concept = data.concept) === null || _data$concept === void 0 ? void 0 : _data$concept.name;
  var shades = mapShades((_data$concept2 = data.concept) === null || _data$concept2 === void 0 ? void 0 : _data$concept2.products);
  var isMultiShade = Boolean(isMultiShadeProduct({
    shades: shades
  }));
  var hasAutoSubscription = mapHasAutoSubscription((_data$concept3 = data.concept) === null || _data$concept3 === void 0 ? void 0 : _data$concept3.labels);
  if (!currentFormatted || !data.concept || !name) {
    return null;
  }
  return {
    brand: (_data$concept$brand = data.concept.brand) === null || _data$concept$brand === void 0 ? void 0 : _data$concept$brand.name,
    buttons: {
      favorites: {
        enabled: false,
        trigger: isMultiShade
      },
      notifyMe: {
        enabled: Boolean((_data$backInStockAvai = data.backInStockAvailability) === null || _data$backInStockAvai === void 0 ? void 0 : _data$backInStockAvai.showBackInStockNotification),
        trigger: isMultiShade
      },
      quickBuy: {
        enabled: mapShowQuickBuyButton(data.concept.labels, shades),
        trigger: isMultiShade || hasAutoSubscription
      }
    },
    code: (_data$productCode = data.productCode) !== null && _data$productCode !== void 0 ? _data$productCode : '',
    image: (_data$imageUrl = data.imageUrl) !== null && _data$imageUrl !== void 0 ? _data$imageUrl : null,
    labels: mapLabels(data.concept.labels),
    name: name,
    price: {
      currentFormatted: currentFormatted,
      old: (_data$formattedPrice$ = data.formattedPrice.price.basicCataloguePrice) !== null && _data$formattedPrice$ !== void 0 ? _data$formattedPrice$ : null,
      previousMinOffer: (_data$formattedPrice$2 = data.formattedPrice.price.previousMinOfferPrice) !== null && _data$formattedPrice$2 !== void 0 ? _data$formattedPrice$2 : null
    },
    rating: (_data$concept$ratingA = data.concept.ratingAverage) !== null && _data$concept$ratingA !== void 0 ? _data$concept$ratingA : 0,
    ratingCount: (_data$concept$ratingC = data.concept.ratingCount) !== null && _data$concept$ratingC !== void 0 ? _data$concept$ratingC : 0,
    shades: shades,
    url: getProductUrl((_data$productCode2 = data.productCode) !== null && _data$productCode2 !== void 0 ? _data$productCode2 : '')
  };
};
//# sourceMappingURL=mapProductBoxProps.js.map